import React, { Component } from "react";
import { connect } from 'react-redux';
import Textarea from 'react-textarea-autosize';
import ReactAutocomplete from 'react-autocomplete';
import autosize from 'autosize';
import defaultImage from '../../../images/video_not_found.png';

import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox");


class ShootingObject extends Component {

    state = {
        currentImage: 0,
        objectIndex: 0,
        imageIndex: 0,
        sliderShow: false,
    }

    componentDidMount(){
        // autosize(this.textarea4);
        autosize(document.querySelector('textarea.object-name'));
    }

    showSlider(item, objectIndex, imageIndex) {
        this.setState({
            currentImage: imageIndex,
            objectIndex,
            imageIndex,
            sliderShow: true
        })
    }

    handleSlideRight(testObj) {
        const {currentImage, objectIndex} = this.state;
        if(!testObj || !testObj.length) return false;
        const length = testObj.length;

        if(currentImage < length) {
            this.setState({
                currentImage: this.state.currentImage + 1
            })
        }
    }

    handleSlideLeft(testObj) {
        const {currentImage} = this.state;
        if(!testObj || !testObj.length) return false;

        if(currentImage !== 0) {
            this.setState({
                currentImage: this.state.currentImage - 1
            })
        }
    }

    render() {

        const {
            items,
            objIndex,
            handleObject,
            handleObjectSelect,
            handleObjectType,
            handleMethod,
            handleFocusMethod,
            handleMethodSelect,
            handleMethodType,
            handleUploadFile,
            deleteUploadFile,
            errorMessages,
            orderFormWidth,
            handleAllExample,
            handleGroup,
            handleFocusGroup,
            handleGroupSelect,
            objectMoreInfoToggle,

            // sliderShowStatus,
            // currentSlideShowImage,
            // openSlideShow,
            // closeSlideShow,

            openCreateMethodModal,
            handleShootingCount,
            order_object_type,
            previewText,
            settings,
        } = this.props;

        const {
                values,
                params,
                allExamples,
                objectComment,
                exampleShooting,
                exampleShootingResults,
                methodData,
                methodAutoCompleteData,
                objectAutoCompleteData,
                groupAutoCompleteData,
                order_object_group_value,
                
                orderMethodTypeIsVideo,
                videoLength,
                photoCount,
                isOpenMoreInfo,
                createMethodButtonShow,
                createMethodStatus,
                description,
                toolValue,
            } = items;
        const { objectValue, methodValue } = values;

        const inputPropsObject = {
          //  onFocus: (e) => handleFocusObject(e.target.value, objIndex)
        }

        const inputPropsGroup = {
            onFocus: (e) => handleFocusGroup(e.target.value, objIndex)
        }

        const inputPropsMethod = {
            onFocus: (e) => handleFocusMethod(e.target.value, objIndex)
        }

        const errObjects = errorMessages.objects && errorMessages.objects[objIndex] || null;
        let moreInfoNewState = errorMessages.objects && errorMessages.objects["moreInfoIsOpen"+objIndex] || false;

        let exampleShootingCrop = [...exampleShootingResults];
        
        if(exampleShootingCrop.length > 5 && orderFormWidth && !allExamples) {
            let images = exampleShootingCrop.slice(Math.max(exampleShootingCrop.length - 5, 1));
            exampleShootingCrop = [...images];
        }

        let exampleShootingLength = exampleShootingResults.length;
        let exampleShootingCropLength = exampleShootingCrop.length;

        moreInfoNewState = (isOpenMoreInfo || moreInfoNewState);

        let isUploadedVideos = exampleShootingResults.filter(item => item.video && !item.is_converted);

        return (
            <div className="order-object">

                <div className="width55">
                    <div className="autocomplete-wrapper textarea-style-container"
                        style={{
                            marginBottom:'20px',
                            minHeight: '50px',
                            paddingBottom: '3px',
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                        <ReactAutocomplete
                            inputProps={{...inputPropsObject, placeholder: "Название объекта"}}
                            items={objectAutoCompleteData.map(autoCompleteItem => {
                                return {...autoCompleteItem, title: autoCompleteItem.full_title, short_title: autoCompleteItem.title}
                            })}
                            renderInput={(props) => (
                                <textarea
                                    {...props}
                                    rows={1}
                                    className="object-name"
                                    style={{
                                        maxHeight: "75px",
                                        // minHeight: "38px",
                                        resize: "none",
                                        fontFamily: 'Arial'
                                    }}
                                />
                            )}
                            shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                            getItemValue={item => item.title}
                            renderItem={(item, highlighted) => 
                                <div
                                    key={item.id}
                                    style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                    {item.title}
                                </div>
                            }
                            renderMenu={(items, value) =>{
                                return <div className="autocomplete-dropdown" children={items}/>
                            }}
                            ref={el => this.textarea4 = el}
                            value={objectValue}
                            onChange={(e) => handleObject(e.target.value, objIndex)}
                            onSelect={(value, item) => handleObjectSelect(item, objIndex)}
                        />
                    </div>

                    {
                        errObjects && errObjects.objectValue ?
                        <div className="input-error-text etmt10">{errObjects.objectValue}</div>
                        : null
                    }
                </div>

                <div className="width35 autocomplete-wrapper" style={{marginBottom:"20px"}}>
                    {
                        orderMethodTypeIsVideo
                        ?
                        <div>
                            <input
                                type="number"
                                min="1"
                                max="10"
                                name="videoLength"
                                // placeholder="Длительность видео в мин."
                                value={videoLength}
                                onChange={(e) => handleShootingCount(e.target, objIndex)}
                                onBlur={(e) => {
                                    if(isNaN(e.target.value) || !e.target.value) handleShootingCount({name: 'videoLength', value: 1}, objIndex)
                                }}
                            />
                            {
                                errObjects && errObjects.count ?
                                <div className="input-error-text etmt10">{errObjects.count}</div>
                                : null
                            }
                            <span className="shooting-count-tag">длина видео (мин.)</span>
                        </div>
                        :
                        <div>
                            <input
                                type="number"
                                min="1"
                                max="10"
                                name="photoCount"
                                // placeholder="Количество кадров"
                                value={photoCount}
                                onChange={(e) => handleShootingCount(e.target, objIndex)}
                                onBlur={(e) => {
                                    if(isNaN(e.target.value) || !e.target.value) handleShootingCount({name: 'photoCount', value: 1}, objIndex)
                                }}
                            />
                            {
                                errObjects && errObjects.count ?
                                <div className="input-error-text etmt10">{errObjects.count}</div>
                                : null
                            }
                            <span className="shooting-count-tag">кол. кадров</span>
                        </div>
                    }
                </div>

                <div className={`object__more-info-sp ${moreInfoNewState ? 'active' : ''}`}>
                    <div style={{width:'100%', marginTop:'15px', marginBottom:'10px'}}>
                        <a className={`object__more-info-link ${moreInfoNewState ? 'active' : ''}`}
                            onClick={() => objectMoreInfoToggle(objIndex)}
                            >{moreInfoNewState ? 'Закрыть дополнительные параметры' : 'Дополнительные параметры'}
                        </a>
                        <div className="makeorder-section-info object-preview-text">Объекты съемки ({previewText})</div>
                    </div>

                    <div className={`object__more-info-inner ${moreInfoNewState ? 'active' : ''}`}>
                        <div className="width55 autocomplete-wrapper" style={{marginBottom:'30px'}}>
                            <ReactAutocomplete
                                inputProps={{...inputPropsGroup, placeholder: "Группа объектов"}}
                                items={groupAutoCompleteData}
                                renderInput={(props) => <input {...props}/>}
                                shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                                getItemValue={item => item.title}
                                renderItem={(item, highlighted) => 
                                    <div
                                        key={item.id}
                                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                        {item.title}
                                    </div>
                                }
                                renderMenu={(items, value) =>{
                                    return <div className="autocomplete-dropdown" children={items}/>
                                }}
                                value={order_object_group_value}
                                onChange={(e) => handleGroup(e.target.value, objIndex)}
                                onSelect={(value, item) => handleGroupSelect(item, objIndex)}
                            />
                        </div>

                        <select
                            value={params.order_object_type}
                            onChange={(e) => handleObjectType(e.target.value, objIndex)}
                            className="form-select width35"
                            style={{marginBottom:'30px'}}>
                        {
                            order_object_type.results.map(elem =>
                                <option key={elem.id} value={elem.id}>{elem.title}</option>
                            )
                        }
                        </select>

                        <select
                            value={params.order_method_type}
                            onChange={(e) => handleMethodType(e.target, objIndex)}
                            className="form-select width30"
                            style={{marginBottom:'35px'}}>
                        {
                            methodData && methodData.results.map(elem =>
                                <option key={elem.id} value={elem.id} data-type={elem.is_video}>{elem.title}</option>
                            )
                        }
                        </select>

                        <div className="width55 autocomplete-wrapper" style={{marginBottom:'30px'}}>
                            <ReactAutocomplete
                                inputProps={{...inputPropsMethod, placeholder: "Метод съемки"}}
                                items={methodAutoCompleteData || []}
                                renderInput={(props) => <input {...props}/>}
                                shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                                getItemValue={item => item.title}
                                renderItem={(item, highlighted) => 
                                    <div
                                        key={item.id}
                                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                        {item.title}
                                    </div>
                                }
                                renderMenu={(items, value) =>{
                                    return <div className="autocomplete-dropdown" children={items}/>
                                }}
                                value={methodValue}
                                onChange={(e) => handleMethod(e.target.value, objIndex)}
                                onSelect={(value, item) => handleMethodSelect(item, objIndex)}
                            />

                            {
                                errObjects && errObjects.methodValue ?
                                <div className="input-error-text etmt10">{errObjects.methodValue}</div>
                                : null
                            }

                            {
                                methodValue && methodValue.trim().length && createMethodButtonShow ?
                                <button className="add-method-button"
                                    onClick={(e) => {
                                            e.preventDefault();
                                            openCreateMethodModal(items, objIndex)
                                        }
                                    }
                                >
                                    {createMethodStatus === 'edit' ? 'Редактировать метод' : 'Создать новый метод'}
                                </button>
                                : null
                            }
                        </div>

                        <div className="width100 textarea-style-container" style={{marginBottom:'30px'}}>
                            <Textarea
                                value={description}
                                placeholder="Описание"
                                className="width100"
                                style={{background:'transparent',color: '#888'}}
                                disabled
                            />
                        </div>

                        <div className="width100 tool-autocomplete" style={{marginBottom:'30px'}}>
                            <input
                                type="text"
                                style={{width:'100%', cursor:'default',color: '#888'}}
                                placeholder="Инструмент"
                                value={toolValue}
                                readOnly
                            /> 
                        </div>

                    </div>
                </div>

                <div className="width100 textarea-style-container" style={{
                        marginBottom:'10px',
                        marginTop:'20px',
                        minHeight: '25px',
                        paddingBottom: '10px'
                    }}>
                    <Textarea
                        value={objectComment}
                        name="objectComment"
                        placeholder="Уточнение"
                        className="width100"
                        style={{backgroundColor:'transparent'}}
                        onChange={(e) => handleShootingCount(e.target, objIndex)}
                    />
                </div>

                {
                    exampleShooting ?
                    <div className="filming-examples width100" style={{marginTop:'20px'}}>
                        <div>
                            <div style={{flexDirection:'row', display:'flex', alignItems:'center',marginBottom:'25px'}}>
                                <h3 style={{width:'auto',flexGrow:1,marginBottom:0,marginTop:0}}>
                                    Пример съемки 
                                    {
                                        exampleShootingResults.length ?
                                        " " + exampleShootingCrop.length + "/" + exampleShootingResults.length
                                        : null
                                    }
                                </h3>
                                {
                                    exampleShootingResults.length > 5 ?
                                    [
                                        // <span key="img1" style={{paddingRight:'5px'}}>{`${exampleShootingCrop.length}/${exampleShootingResults.length}`}</span>,
                                        <a key="img2" href="" style={{fontSize:'14px'}} onClick={(e) => {e.preventDefault(); handleAllExample(allExamples, objIndex)}}>{allExamples ? 'Скрыть' : 'Показать все'}</a>
                                    ]
                                    : null
                                }
                            </div>
                            <ul className="examples">
                                {
                                    exampleShootingCrop.map((item, index) => {
                                        let fileEx = item.type;
                                        let locale = false;

                                        if(item.image && !item.type) fileEx = 'image';
                                        if(item.video && !item.type) fileEx = 'video';
                                        if(item.type) locale = true;

                                        if(fileEx !== "image" && fileEx !== "video") return false;

                                        return (<li key={index}>
                                                    <button
                                                        className="examples__delete-icon"
                                                        onClick={(e) => {
                                                            let indx = index;
                                                            if(exampleShootingLength > 5) {
                                                                indx = ((exampleShootingLength - exampleShootingCropLength) + index)
                                                            }
                                                            
                                                            e.preventDefault();
                                                            deleteUploadFile(indx, objIndex)
                                                        }}
                                                    >
                                                    </button>
                                                    {
                                                        fileEx === "image" ?
                                                        <a className="img" href={item.image} data-fancybox>
                                                            <img /*onClick={() => this.showSlider(item, objIndex, index)}*/ src={item.image} />
                                                        </a>
                                                        :
                                                        fileEx === 'video'
                                                        ?
                                                        (item.id && item.is_converted) ?
                                                        <div style={{height:'100px',width:'100px',position:'relative',zIndex:1}}>
                                                            <a href={item.video} data-fancybox className="mm-video">
                                                                {/* <video className="fancybox-video" src={item.video} width="100" height="95" controls="controls"></video> */}
                                                                <i className="play-icon-video"></i>
                                                                <img style={{borderRadius:'20px'}} src={item.thumb_image} />
                                                            </a>
                                                        </div>
                                                        :
                                                        <div className="hs-video-sp" style={{height:'100px',width:'100px',position:'relative',zIndex:1}}>
                                                            <img style={{borderRadius:'20px'}} src={defaultImage} />
                                                            {/* <video className="fancybox-video" src={item.video} width="100" height="95" controls="controls">
                                                            </video>

                                                            <a data-fancybox  className="mm-video">
                                                                <video className="fancybox-video" src={item.video} width="100" height="95" controls="controls">
                                                                </video>
                                                            </a> */}
                                                        </div>
                                                        :null
                                                    }
                                                </li>)
                                    })
                                }
                                <li className="add-example">
                                    <div className="img"></div>
                                    <input
                                        type="file" className="add-example__input"
                                        accept={orderMethodTypeIsVideo ? settings.allow_upload_only_mp4 ? "video/mp4,video/webm,video/ogg" : "video/*" : "image/jpeg,image/png,image/gif"}
                                        onChange={(e) => handleUploadFile(e, objIndex)}
                                        onClick={(event)=> { 
                                            event.target.value = null
                                        }}/>
                                </li>
                            </ul>

                            {
                                isUploadedVideos.length ?
                                <div style={{padding:'15px', background:'rgb(255, 219, 172)'}}>
                                    Видео будет доступно для просмотра после загрузки и конвертации на сервере
                                </div>
                                : null
                            }

                        </div>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        order_object_type: state.data.order_object_type,
        settings: state.data['settings']
    };
};
export default connect(mapStateToProps)(ShootingObject);


// WEBPACK FOOTER //
// ./src/components/MakeOrder/NewAndEdit/ShootingObject.js